import type { TextProps } from "@octopusdeploy/design-system-components";
import { Text } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { ParseHelper } from "../../../utils";
import type { FormFieldProps } from "../FormFieldProps";
export type NumberOtherProps = Omit<TextProps, keyof FormFieldProps<string> | "type">;
type NumberProps = NumberOtherProps & FormFieldProps<number | undefined>;
/* @deprecated
 * Deprecated: 17/11/2025
 * Migration guidelines: This component is deprecated and will be removed in a future release.
 * This is part of our ongoing improvements to forms and input components to enhance usability and accessibility.
 *
 * Please migrate to the NumberField component where possible.
 *
 * We recognize NumberField has different styling; if that prevents an immediate swap, you may continue using this
 * component until all the new form components are in place.
 */
export function DeprecatedNumber(props: NumberProps) {
    const { value, onChange, ...otherProps } = props;
    const handleChange = (newValue: string) => {
        const newValueParsed = newValue ? ParseHelper.safeParseFloat(newValue, 0) : undefined;
        if (onChange)
            onChange(newValueParsed);
    };
    return <Text type="number" onChange={handleChange} value={value === undefined ? "" : value.toString()} {...otherProps}/>;
}
